import { rustdeskLaunchUrl } from '../api/remoteConnectRustdesk'

/**
 * Butonul "Remote connect" - fostul `#remoteConnectModal` din
 * `opteemum/devices/details/modals.php` (si copiile lui din Proactivitee si de
 * pe tichet), care crea o sesiune ScreenConnect si arata "Join Session".
 *
 * ScreenConnect e scos din uz (decizia din 12 septembrie 2026): Remote Connect
 * in v4 e NUMAI RustDesk, deci butonul nu mai are nimic de asteptat de la
 * server - deschide DIRECT pagina de lansare (sub /app), in fila noua, cum
 * deschidea portalul `hostUrlJoin` pe RustDesk. Toate regulile (dreptul,
 * hotarul pe firma, consimtamantul) sunt pe pagina aia, nu aici.
 *
 * Aceeasi tinta pentru toate butoanele: lista Remote Connect, Remote
 * Operations de pe fisa, fila Remote Connect a tichetului. Ce difera e doar
 * TINTA (`RemoteConnectTarget`): masina, si pe tichet tichetul.
 */

export type RemoteConnectTarget = {
  device: number
  ticket?: number
}

/**
 * Tinta dintr-un buton scris ca HTML (`data-target="#remoteConnectModal"
 * data-device=... data-ticket=...`) - butonul verde de pe randurile listei
 * Remote Connect vine asa de la server.
 */
export function remoteConnectTargetOf(el: EventTarget | null): RemoteConnectTarget | null {
  if (!(el instanceof Element)) return null
  const button = el.closest('[data-target="#remoteConnectModal"],[data-target="#remoteConnectModalTest"]')
  if (!(button instanceof HTMLElement)) return null
  const device = Number(button.dataset.device ?? 0)
  if (!(device > 0)) return null
  const ticket = Number(button.dataset.ticket ?? 0)
  return { device, ticket: ticket > 0 ? ticket : undefined }
}

/** Pagina de lansare RustDesk, in fila noua. */
export function openRemoteConnect(target: RemoteConnectTarget): void {
  window.open(rustdeskLaunchUrl(target.device, target.ticket ?? 0), '_blank', 'noopener,noreferrer')
}

/**
 * Prinderea clicului pe butoanele scrise ca HTML de sub `children` (lista
 * Remote Connect, unde butonul de pe rand vine de la server). Pentru butoane
 * React se cheama `openRemoteConnect` direct.
 */
export function RemoteConnectHost({ children }: { children: React.ReactNode }) {
  return (
    <div
      onClick={(e) => {
        const found = remoteConnectTargetOf(e.target)
        if (found) {
          e.preventDefault()
          openRemoteConnect(found)
        }
      }}
    >
      {children}
    </div>
  )
}
